import * as React from "react";

import {cst, cstAssign}             from "@Common/react/chain-services";
import {consumeContext}             from "@Common/react/context";
import {UseState}                   from "@Common/react/use-state";
import {Types}                      from "@Common/types";
import {ConfirmDialog}              from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {ModalService3}              from "@Common/ui-components/modal-service-3/modal-service-3";
import {needsConfirmation}          from "@Common/ui-components/needs-confirmation/needs-confirmation";

import {ConfirmTab}                 from "./tabs/confirm-tab/confirm-tab";
import {CustomizationTab}           from "./tabs/customization-tab/customization-tab";
import {GeneralTab}                 from "./tabs/general-tab/general-tab";
import {LoginTab}                   from "./tabs/login-tab/login-tab";
import {USER_TAB}                   from "./user-create-tabs";

interface VarStack {
    step: Types.Common.React.UseState.UseStateNext<number>,
    agent: Types.Common.React.UseState.UseStateNext<{
        inputs: {}
        errors: {}
    }>,
    confirmCloseDialog: any,
    modal: Types.Common.UiComponents.ModalService3.ModalService3Next<null>,
    routerHistory: any,
}

export const UserCreateModal = ({initShow, initValue={}, reload, next: rootNext}) => cst<VarStack>(
    consumeContext("routerHistory"),
    cstAssign("step", (_, next) => UseState({next, initValue: USER_TAB.GENERAL})),
    cstAssign("agent", (_, next) => UseState({
        initValue: {
            inputs: initValue,
            errors: {},
        },
        next
    })),
    cstAssign("confirmCloseDialog", (_, next) => ConfirmDialog({next})),
    cstAssign("modal", ({confirmCloseDialog, step, agent, routerHistory}, next) => (
        initShow ? (
            <ModalService3 {...{
                initShow: true,
                width: 555.5,
                hideCloseButton: true,
                xdQaName: "Create User Modal",
                onClose: async () => {
                    const proceed = await needsConfirmation({
                        confirmDialog: confirmCloseDialog
                    });
                    if(proceed) {
                        step.onChange(USER_TAB.GENERAL);
                        agent.onChange({
                            inputs: {},
                            errors: {},
                        });
                        reload(),
                        routerHistory.replace('/account/admin/user');
                        window.opener?.postMessage?.({type: "leftAgentCreate"});
                        return true
                    }
                    return false;
                },
                rootNext,
                next,
            }}/>
        ) : (
            rootNext()
        )
    )),
    ({step, modal, agent, routerHistory}) => (
        step.value === USER_TAB.GENERAL ? (
            GeneralTab({step, modal, agent})
        ) : step.value === USER_TAB.LOGIN ? (
            LoginTab({step, modal, agent})
        ) : step.value === USER_TAB.CUSTOMIZATION ? (
            CustomizationTab({step, modal, agent})
        ) : step.value === USER_TAB.CONFIRM ? (
            ConfirmTab({step, modal, agent, reload})
        ) : (
            routerHistory.replace('/account/admin/user')
        )
    )
);
